var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6574 10.8333H16.1112V13.8889L15.0926 13.2109L14.0741 13.8889V10.8333H11.5278C11.2477 10.8333 11.0186 11.0625 11.0186 11.3426V17.4537C11.0186 17.7338 11.2477 17.963 11.5278 17.963H18.6574C18.9375 17.963 19.1667 17.7338 19.1667 17.4537V11.3426C19.1667 11.0625 18.9375 10.8333 18.6574 10.8333ZM6.43523 8.7963H13.5649C13.8449 8.7963 14.0741 8.56714 14.0741 8.28704V2.17593C14.0741 1.89584 13.8449 1.66667 13.5649 1.66667H11.0186V4.72223L10 4.04428L8.98152 4.72223V1.66667H6.43523C6.15513 1.66667 5.92597 1.89584 5.92597 2.17593V8.28704C5.92597 8.56714 6.15513 8.7963 6.43523 8.7963ZM8.47226 10.8333H5.92597V13.8889L4.90745 13.2109L3.88893 13.8889V10.8333H1.34263C1.06254 10.8333 0.833374 11.0625 0.833374 11.3426V17.4537C0.833374 17.7338 1.06254 17.963 1.34263 17.963H8.47226C8.75236 17.963 8.98152 17.7338 8.98152 17.4537V11.3426C8.98152 11.0625 8.75236 10.8333 8.47226 10.8333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMall);
export default __webpack_public_path__ + "static/media/mall.d442f2326a84af511962c5ca85a3f2c6.svg";
export { ForwardRef as ReactComponent };